import axiosInstance from "../axios_instance";

export async function createService(body) {
  try {
    return await axiosInstance.post(`services/`, body);
  } catch (error) {
    return error;
  }
}

export async function updateService(body, id) {
  try {
    return await axiosInstance.put(`services/${id}`, body);
  } catch (error) {
    return error;
  }
}

export async function updateMyService(body, id) {
  try {
    return await axiosInstance.put(`myservices/${id}`, body);
  } catch (error) {
    return error;
  }
}

export async function deleteService(id, body) {
  try {
    const obj = { ...body, requestedAccess: 'Edit' }
    return await axiosInstance.delete(`services/${id}`, obj);
  } catch (error) {
    return error;
  }
}

export async function getServiceById(id) {
  try {
    return await axiosInstance.get(`services/${id}`);
  } catch (error) {
    return error;
  }
}

export async function getAllServices(body) {
  try {
    return await axiosInstance.post(`services/get`, body);
  } catch (error) {
    return error;
  }
}

export async function getUsersByServiceId(id) {
  try {
    return await axiosInstance.get(`services/getUsers/${id}`);
  } catch (error) {
    return error;
  }
}

export async function getMyServices(body) {
  try {
    return await axiosInstance.post(`myservices/getAllServiceRegistrations`, body);
  } catch (error) {
    return error;
  }
}

export async function getAllServiceRegistrationsCount(userID) {
  try {
    return await axiosInstance.get(`myservices/getUserServiceRegistrationsCount/${userID}`);
  } catch (error) {
    return error;
  }
}
